import { render, staticRenderFns } from "./StoreStockInventory.vue?vue&type=template&id=5db64276&scoped=true&"
import script from "./StoreStockInventory.vue?vue&type=script&lang=js&"
export * from "./StoreStockInventory.vue?vue&type=script&lang=js&"
import style0 from "./StoreStockInventory.vue?vue&type=style&index=0&id=5db64276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db64276",
  null
  
)

export default component.exports